module.exports = __webpack_public_path__ + "static/greybunnymain-3019cf4eec50c94981772b70ac4948c9.png";